import axios from "axios";
import React, { useCallback, useEffect, useState } from "react";

import { Spinner } from "react-bootstrap";
import { listSettingsFields } from "../models/fieldSettings";
import { PS_WEB, getLs, setLs, upperCase } from "../utils";
import PsContext from "./index";

import jwt from "expo-jwt";

const PsContextProvider = (props) => {
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);
  const breakpoint = 620;

  const token = PS_WEB;

  useEffect(() => {
    /* Inside of a "useEffect" hook add an event listener that updates
       the "width" state variable when the window size changes */
    window.addEventListener("resize", () => setWindowWidth(window.innerWidth));

    /* passing an empty array as the dependencies of the effect will cause this
       effect to only run when the component mounts, and not each time it updates.
       We only want the listener to be added once */
  }, []);

  const isMobileView = () => (windowWidth < breakpoint ? true : false);

  const checkUserLogged = () => {
    return getLs("billnote_logged") || "no";
  };

  const checkUserMobilePassword = () => {
    return getLs("billnote_mob_pass") || "";
  };

  const checkMobileUserId = () => {
    return getLs("billnote_mob_uuid") || "";
  };

  const getAdminUser = () => {
    return getLs("billnote_user_data") &&
      getLs("billnote_user_data") !== "undefined"
      ? JSON.parse(getLs("billnote_user_data"))
      : [];
  };

  const getLoggedCollege = () => {
    return getLs("billnote_college_data") &&
      getLs("billnote_college_data") !== "undefined"
      ? JSON.parse(getLs("billnote_college_data"))
      : [];
  };

  const getAdminApi = () => {
    return getLs("billnote_api") || "";
  };

  const getSettings = () => {
    /*return getLs("billnt_settings") && getLs("billnt_settings") !== "undefined"
      ? JSON.parse(getLs("billnt_settings"))
      : [];*/

    if (getLs("billnt_settings") && getLs("billnt_settings") !== "undefined") {
      let set = getLs("billnt_settings");
      if (!set.includes("{")) {
        let decoded = jwt.decode(set, token);
        setSettings(decoded);
        return decoded;
      }
      return [];
    } else {
      setSettings([]);
      return [];
    }
  };

  const getAcyear = () => {
    return getLs("billnt_acyear_cur") &&
      getLs("billnt_acyear_cur") !== "undefined"
      ? JSON.parse(getLs("billnt_acyear_cur"))
      : [];
  };

  const getPermissions = () => {
    return getLs("billnt_user_permissions") &&
      getLs("billnt_user_permissions") !== "undefined"
      ? JSON.parse(getLs("billnt_user_permissions"))
      : [];
  };

  const getCashbook = () => {
    return getLs("billnt_user_cashbook") &&
      getLs("billnt_user_cashbook") !== "undefined"
      ? JSON.parse(getLs("billnt_user_cashbook"))
      : [];
  };

  const [state, setState] = useState([]);

  const [logged, setLogged] = useState(checkUserLogged());

  const [mobilePass, setMobilePass] = useState(checkUserMobilePassword());
  const [mobileUserId, setMobileUserId] = useState(checkMobileUserId());

  const [user, setUser] = useState(getAdminUser());
  const [api, setApi] = useState(getAdminApi());

  const [backgroundProcess, setBackgroundProcess] = useState(false);

  //const [settings, setSettings] = useState(getSettings());
  const [settingsUpdated, setSettingsUpdate] = useState(false);
  const [settings, setSettings] = useState([]);
  const [acyear, setSAcyear] = useState(getAcyear());

  const [accessPermissions, setAccessPermissions] = useState(getPermissions());
  const [cashbook, setCashbook] = useState(getCashbook());

  // for affiliated college
  const [loggedCollege, setLoggedCollege] = useState(getLoggedCollege());

  const [selectedAdmissionYear, setadmissionYear] = useState("2022");

  const [loader, setLoader] = useState(false);

  useEffect(() => {
    if (settings) forceUpdate();
  }, [settings]);

  useEffect(() => {
    getSettings();
  }, [settingsUpdated]);

  const saveLogin = (
    user,
    api,
    permissions = [],
    cb = [],
    loggedClg = false
  ) => {
    /*var now = new Date();
    var minutes = 1;
    now.setTime(now.getTime() + (minutes * 60 * 1000));*/

    setLs("billnote_user_data", JSON.stringify(user));
    setUser(user);

    setLs("billnote_api", api);
    setApi(api);

    setLs("billnt_user_permissions", JSON.stringify(permissions));
    setAccessPermissions(permissions);

    setLs("billnt_user_cashbook", JSON.stringify(cb));
    setCashbook(cb);

    if (loggedClg) {
      setLs("billnote_college_data", JSON.stringify(loggedClg));
      setLoggedCollege(loggedClg);
    }

    //setLs('mat_logged', 'yes');
    //setLogged('yes');
  };

  const logout = () => {
    setLs("billnote_user_data", false);
    setUser([]);
    setSAcyear([]);
    setLs("billnote_api", "");
    setLs("billnt_acyear_cur", false);
    setApi(null);
    axios.defaults.headers.common["Api-Token"] = "";
    setLs("billnt_user_permissions", "");
    setAccessPermissions([]);
    setCashbook([]);
    setLs("billnote_logged", "no");
    setLs("billnote_college_data", false);
    setLoggedCollege([]);
    setLogged("no");
  };

  const decode = (v) => {
    try {
      return jwt.decode(v, token);
    } catch (er) {
      return [];
    }
  };

  const getDecodeApi = () => {
    try {
      let decoded = jwt.decode(api, token);
      return decoded;
    } catch (er) {
      return [];
    }
  };

  const setEncodeApi = (decoded) => {
    try {
      let encoded = jwt.encode(decoded, token);
      axios.defaults.headers.common["Api-Token"] = encoded;
      setLs("billnote_api", encoded);
      setApi(api);
    } catch (er) {}
  };

  const updateUser = (us) => {
    if (us.academic_department) {
      let decoded = getDecodeApi();
      decoded.academic_department = us.academic_department;
      setEncodeApi(decoded);
    }
    setLs("billnote_user_data", JSON.stringify(us));
    setUser(us);
    forceUpdate();
  };

  const updateCashbook = (cb) => {
    let decoded = getDecodeApi();
    decoded.allowd_cash_books = cb.id;
    setEncodeApi(decoded);
    setLs("billnt_user_cashbook", JSON.stringify(cb));
    setCashbook(cb);
    forceUpdate();
  };

  const updateLogged = () => {
    setLs("billnote_logged", "yes");
    setLogged("yes");
  };

  const loadSettings = () => {
    //setLoader(true);
    try {
      listSettingsFields("1", "1").then((res) => {
        if (res && res.status == "1") {
          if (res.permissions) {
            setLs("billnt_user_permissions", JSON.stringify(res.permissions));
            setAccessPermissions(res.permissions);
          }
          if (res.data) {
            /*let decoded = jwt.decode(res.data, token);
            setLs("billnt_settings", JSON.stringify(decoded));
            setSettings(decoded);*/

            setLs("billnt_settings", res.data);
            setSettingsUpdate(!settingsUpdated);
          }
          //setLoader(false);
        }
      });
    } catch (er) {
      setLoader(false);
    }
  };

  const settingValue = (key) => {
    let m = settings && settings.find((item) => item.field_name == key);
    return m && m.field_name ? m.field_value : false;
  };

  const updateAcyear = (v) => {
    setSAcyear(v);
    setLs("billnt_acyear_cur", JSON.stringify(v));
  };

  const updateMobileUserId = (v) => {
    setMobileUserId(v);
    setLs("billnote_mob_uuid", v);
  };

  const updateMobilePassword = (v) => {
    setLs("billnote_mob_pass", v);
    setMobilePass(v);
  };

  const setStorage = (storageName, storageValue) => {
    setLs(storageName, storageValue);
  };

  const getStorage = (storageName) => {
    return getLs(storageName); /* && getLs(storageName) !== "undefined"
      ? getLs(storageName)
      : null;*/
  };

  const allowedAccess = (module, action) => {
    let permissions = accessPermissions;
    try {
      if (upperCase(user.user_type) == "DEV") return true;

      /* if (props.roleGroup && props.roleGroup.length > 0) {
        let allowedRoleGroups = findCommonElement(
          permissions.map((item) => item.role_group),
          props.roleGroup
        );
        return allowedRoleGroups;
      }*/

      if (!module || !action) return false;

      if (upperCase(module) == "ANY" && upperCase(action) == "ANY") return true;

      let moduleExist = permissions.filter(
        (item) => upperCase(item.module) == upperCase(module)
      );

      if (moduleExist.length < 1) return false;

      let allowed = moduleExist.find(
        (item) => upperCase(item.action_name) == upperCase(action)
      );

      return allowed ? true : false;
    } catch (er) {
      return false;
    }
  };

  const forceUpdate = useCallback(() => setState({}), []);

  return (
    <PsContext.Provider
      value={{
        state: state,
        logged: logged,
        user: user,
        acyear: acyear,
        api: api,
        saveLogin: saveLogin,
        updateUser: updateUser,
        updateLogged: updateLogged,
        setBackgroundProcess: setBackgroundProcess,
        backgroundProcess: backgroundProcess,
        logout: logout,
        loadSettings: loadSettings,
        settingValue: settingValue,
        selectedAdmissionYear: selectedAdmissionYear,
        updateAcyear: updateAcyear,
        accessPermissions: accessPermissions,
        allowedAccess: allowedAccess,
        cashbook: cashbook,
        updateCashbook: updateCashbook,
        isMobileView: isMobileView,
        mobilePass: mobilePass,
        mobileUserId: mobileUserId,
        updateMobileUserId: updateMobileUserId,
        updateMobilePassword: updateMobilePassword,
        setLoader: setLoader,
        setStorage: setStorage,
        getStorage: getStorage,
        decode: decode,
        getDecodeApi: getDecodeApi,
      }}
    >
      {loader && (
        <div className="ps__loader">
          <div className="ps__loader__body">
            <div className="ps__loader__content">
              <Spinner animation="grow" size="lg" />
              <br />
              Please Wait
            </div>
          </div>
        </div>
      )}

      {props.children}
    </PsContext.Provider>
  );
};

export default PsContextProvider;
